// Central data-testid constants
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const LANDING = {
  container: "landing-container",
  signInCta: "landing-sign-in-cta",
  trustBanner: "landing-trust-banner",
};

export const SIGNIN = {
  container: "signin-container",
  emailInput: "signin-email-input",
  submitButton: "signin-submit-button",
  successCard: "signin-success-card",
  devLink: "signin-dev-link",
  errorAlert: "signin-error-alert",
};

export const AUTH_VERIFY = {
  container: "auth-verify-container",
  status: "auth-verify-status",
};

export const DASH_HELP = {
  open: "dash-help-open",
  panel: "dash-help-panel",
  input: "dash-help-input",
  send: "dash-help-send",
  messages: "dash-help-messages",
};

export const TOPBAR = {
  container: "topbar-container",
  userEmail: "topbar-user-email",
  signOutButton: "topbar-signout-button",
};

export const ADMIN_DASH = {
  container: "admin-dashboard",
  newOrgButton: "admin-new-org-button",
  allowlistButton: "admin-loader-allowlist-button",
  orgsTable: "admin-orgs-table",
  projectsTable: "admin-projects-table",
  projectSearch: "admin-project-search-input",
  projectStatusFilter: "admin-project-status-filter",
  projectResults: "admin-project-results-count",
  projectClearFilters: "admin-project-clear-filters",
  projectEmptyFilter: "admin-project-empty-filter",
  projectRow: (id) => `admin-project-row-${id}`,
  emptyOrgs: "admin-empty-orgs",
  auditTable: "admin-audit-table",
};

export const ADMIN_ALLOWLIST = {
  container: "admin-loader-allowlist",
  urlInput: "admin-loader-url-input",
  descriptionInput: "admin-loader-description-input",
  addButton: "admin-loader-add-button",
  refreshButton: "admin-loader-refresh-button",
  errorAlert: "admin-loader-error-alert",
  entry: (id) => `admin-loader-entry-${id}`,
  retireButton: (id) => `admin-loader-retire-${id}`,
  restoreButton: (id) => `admin-loader-restore-${id}`,
};

export const ADMIN_NEW_ORG = {
  container: "admin-new-org",
  nameInput: "admin-new-org-name",
  submit: "admin-new-org-submit",
};

export const ADMIN_ORG = {
  container: "admin-org-detail",
  addWebsiteButton: "admin-org-add-website",
  websiteUrlInput: "admin-org-website-url",
  websitePlatformSelect: "admin-org-website-platform",
  websiteSubmit: "admin-org-website-submit",
  inviteButton: "admin-org-invite-button",
  inviteEmail: "admin-org-invite-email",
  inviteWebsiteSelect: "admin-org-invite-website",
  inviteSiteKey: "admin-org-invite-site-key",
  inviteLoaderSelect: "admin-org-invite-loader",
  inviteSubmit: "admin-org-invite-submit",
  inviteSuccessLink: "admin-org-invite-dev-link",
};

export const ADMIN_PROJECT = {
  container: "admin-project-detail",
  status: "admin-project-status",
  markNeedsAssistance: "admin-project-mark-needs-assistance",
  resolveAssistance: "admin-project-resolve-assistance",
  auditList: "admin-project-audit-list",
  eventList: "admin-project-event-list",
};

export const CLIENT_DASH = {
  container: "client-dashboard",
  emptyState: "client-empty-state",
  projectRow: (id) => `client-project-row-${id}`,
};

export const WIZARD = {
  container: "client-wizard",
  progressBar: "client-wizard-progress",
  step: (n) => `wizard-step-${n}`,
  confirmCompany: "wizard-company-input",
  confirmUrl: "wizard-url-input",
  confirmPlatform: "wizard-platform-select",
  confirmSubmit: "wizard-confirm-submit",
  authorizeCheckbox: "wizard-authorize-checkbox",
  authorizeSubmit: "wizard-authorize-submit",
  copySnippet: "wizard-copy-snippet",
  verifyButton: "wizard-verify-button",
  verifyResult: "wizard-verify-result",
  goLiveButton: "wizard-golive-button",
  assistancePanel: "wizard-assistance-panel",
  requestAssistance: "wizard-request-assistance",
  assistanceReason: "wizard-assistance-reason",
  confirmAssistance: "wizard-confirm-assistance",
  revokeButton: "wizard-revoke-button",
  confirmRevokeButton: "wizard-confirm-revoke-button",
  revokeReasonInput: "wizard-revoke-reason",
  statusPill: "wizard-status-pill",
  errorAlert: "wizard-error-alert",
};

export const ONBOARDING = {
  container: "client-onboarding",
  autosaveState: "onboarding-autosave-state",
  completionBar: "onboarding-completion-bar",
  completionPct: "onboarding-completion-pct",
  blockersList: "onboarding-blockers-list",
  field: (key) => `onboarding-field-${key}`,
  submit: "onboarding-submit-button",
  statusPill: "onboarding-status-pill",
  clarificationsList: "onboarding-clarifications",
  clarificationReplyInput: "onboarding-clarification-reply-input",
  clarificationReplyButton: "onboarding-clarification-reply-button",
  errorAlert: "onboarding-error",
};

export const ADMIN_ONBOARDING = {
  container: "admin-onboarding-review",
  status: "admin-onboarding-status",
  answersList: "admin-onboarding-answers",
  startReview: "admin-onboarding-start-review",
  requestClarificationMessage: "admin-onboarding-clarification-message",
  requestClarificationVisibility: "admin-onboarding-clarification-visibility",
  requestClarificationSubmit: "admin-onboarding-clarification-submit",
  approve: "admin-onboarding-approve",
  clarificationsList: "admin-onboarding-clarifications",
};
